<template>
  <div class="library-breadcrumbs">
    <a v-for="directory in breadcrumbs" :key="directory.id" @click="$emit('load-directory',directory.id)">{{directory.root ? 'Library' : directory.name}}<v-icon color="accent">bhi-chevron-right</v-icon></a>
    <div class="search" v-if="search" @click.stop="$emit('refresh-results')">Search results for: <span class="search-term">{{search}}</span> <v-btn rounded outlined elevation="0" small color="accent" v-if="breadcrumbs.length>0" @click="$emit('refresh-results')"><v-icon size="14">bhi-chevron-left</v-icon>Back to search results</v-btn> <v-btn @click.stop="$emit('clear-search')" rounded elevation="0" color="accent" class="search-clear" small outlined><v-icon size="10">bhi-close</v-icon> Clear search</v-btn></div>
    
  </div>
</template>
<script>
export default {
  name: 'LibraryBreadcrumbs',
  props: {
    breadcrumbs: {
      type: Array,
      default: () => ([])
    },
    search: {
      type: [Boolean, String],
      default: false
    }
  },
  data () {
    return {
      
    }
  },
  methods: {
    
  }
}
</script>

<style lang="scss">
.library-breadcrumbs {
  padding:20px 8px;
  a {
    font-size: 20px;
    font-weight: 700;
    color: $bh-blue;
    .v-icon {
      margin: 0 13px;
    }
    &:last-child {
      color: $bh-gray;
      .v-icon {
        display: none;
      }
    }
    &:only-child {
      display: none;
    }
  }
  .search {
    font-size: 20px;
    font-weight: 700;
    color: $bh-gray;
    display: inline-block;
    &-term {
      color: $bh-blue;
    }
    .v-btn {
      margin-left: 10px;
      .v-icon {
        margin-right: 10px;
      }
    }
  }
}
</style>